module.exports = __webpack_public_path__ + "img/sidebar-icon-admin.1feb7977.svg";